//  These are the common page size/count options across the app.
export const STANDARD_COUNT_OPTIONS = [
  5,
  10,
  20,
  50,
];

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 20;
